import './error404.less'

import {Fetcher, m, wrap} from '@codeurs/front'
import {Component, Fragment} from 'react'
import {Links} from 'types'
import {t} from 'util/i18n'
import {style} from 'util/style'
import {Layout} from 'views/layout'
import {Newsletter, NewsLetterType} from 'views/partials/newsletter'
import {Theme} from 'views/theme'
import {SitemapContent, SitemapItemType} from './sitemap'

const styles = style('error404')

@wrap(Layout)
export class Error404 extends Component<{
  data: {
    menu: Links
    subsite: string
    newsletter: NewsLetterType
    language: string
  }
}> {
  render() {
    const {menu, subsite, newsletter, language} = this.props.data
    let homeLink = menu && menu.home && menu.home.url
    if ((subsite === '2050' || subsite === 'error2050') && menu && menu['2050'])
      homeLink = menu['2050'].url
    if ((subsite === 'cbam' || subsite === 'errorcbam') && menu && menu['cbam'])
      homeLink = menu['cbam'].url
    return (
      <Fragment>
        <div class={styles}>
          <Theme.Container className={styles('inner')}>
            <Theme.H1 class={styles('title')}>{t('error404.title')}</Theme.H1>
            <p class={styles('text')}>{t('error404.text')}</p>
            <Theme.Button class={styles('btn')} to={homeLink}>
              {t('error404.btn')}
            </Theme.Button>
            <div className={styles('inner-sitemap')}>
              <Fetcher<{sitemap: Array<SitemapItemType>}> url="/sitemap?json">
                {({data}) => data && <SitemapContent sitemap={data.sitemap} />}
              </Fetcher>
            </div>
          </Theme.Container>
        </div>
        <Newsletter {...newsletter} language={language} />
      </Fragment>
    )
  }
}
